module.exports = __webpack_public_path__ + "img/abnormal_notification_Color.b15fd8af.svg";